import { Button, ButtonProps } from '@chakra-ui/react';
import * as React from 'react';
import { SvgIcon } from './chakra-components';

export function FabButton({ src, ...props }: ButtonProps & { src: SvgIcon }) {
	return <Button bg='transparent' color='white' {...props}>
		<SvgIcon src={src} w={'6'} h={'6'} />
	</Button>;
}